var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalReviewsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.555,
    height: 20.908,
    viewBox: "0 0 16.555 20.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6247",
    "data-name": "Group 6247",
    transform: "translate(-15.22 -12.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11616",
    "data-name": "Group 11616",
    transform: "translate(-38.076 12.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49469",
    "data-name": "Path 49469",
    d: "M77.67,10.978h-.735v15.2a1.8,1.8,0,0,1-1.8,1.8H64.259v.752a.613.613,0,0,0,.613.613h12.8a.613.613,0,0,0,.613-.613V11.591A.612.612,0,0,0,77.67,10.978ZM64.927,8.789,62.086,11.63h2.84Zm3.813,6.876A2.076,2.076,0,0,0,66.7,17.428h4.09A2.057,2.057,0,0,0,68.74,15.665Z",
    transform: "translate(-8.431 -8.43)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49470",
    "data-name": "Path 49470",
    d: "M67.319,17.747V.613A.613.613,0,0,0,66.707,0H57.721V3.812a.613.613,0,0,1-.612.612H53.3V17.747a.613.613,0,0,0,.613.613h12.8A.613.613,0,0,0,67.319,17.747ZM57.025,9.092q0-.024,0-.047a3.293,3.293,0,0,1,1.689-2.624,1.97,1.97,0,1,1,3.187,0,3.3,3.3,0,0,1,1.683,2.562q0,.029,0,.059v.569a.613.613,0,0,1-.613.613H57.637a.613.613,0,0,1-.613-.613Zm7.367,6.252H56.2a.613.613,0,0,1,0-1.225h8.2a.613.613,0,1,1,0,1.225Zm0-2.45H56.2a.613.613,0,0,1,0-1.225h8.2a.613.613,0,0,1,0,1.225Z",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49471",
    "data-name": "Path 49471",
    d: "M208.282,111.436a.745.745,0,1,0-.745.745A.745.745,0,0,0,208.282,111.436Z",
    transform: "translate(-147.229 -106.171)",
    fill: "#4165f6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalReviewsIcon);
export default __webpack_public_path__ + "static/media/Legal Reviews Icon.a38d398e93895d916a97ea3b7aff5ed0.svg";
export { ForwardRef as ReactComponent };